import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import pointTriste from "../../img/pointTriste.png";

// Hook para capturar tamaño de la ventana
const useWindowSize = () => {
	const [size, setSize] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	useEffect(() => {
		const handleResize = () => {
			setSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return size;
};

export const SolicitudExitosa = ({
	isOpen,
	onClose,
	titulo,
	subtitulo,
	color,
	li1,
	li2,
	li3,
	ruta,
	icono = "normal",
	showConfetti = false,
	// Los mensajes del pie ("Regresa para ver el detalle..." / "¡Gracias por
	// confiar en POINT!") solo tienen sentido cuando existe una solicitud real
	// de la que volver. En escenarios donde no se creó ninguna (cédula no
	// encontrada, solicitud bloqueada) ese pie queda fuera de tono.
	mostrarPie = true,
}) => {
	const navigate = useNavigate();
	const { width, height } = useWindowSize();
	const [mostrarConfeti, setMostrarConfeti] = useState(false);
	const dialogRef = useRef(null);

	useEffect(() => {
		if (isOpen) {
			setMostrarConfeti(true);
			const timer = setTimeout(() => setMostrarConfeti(false), 9000); // 🎉 Dura 9 segundos
			return () => clearTimeout(timer);
		}
	}, [isOpen]);

	// Foco inicial en el diálogo y cierre con Escape — accesibilidad de modal.
	useEffect(() => {
		if (!isOpen) return;
		dialogRef.current?.focus();
		const onKeyDown = (e) => {
			if (e.key === "Escape") handleCerrar();
		};
		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOpen]);

	const handleCerrar = () => {

		
		// PRIMERO navegar si hay ruta
		if (ruta && ruta !== "") {
			navigate(ruta, { replace: true });
		} else {
			console.log('⚠️ No hay ruta para navegar');
		}
		
		// LUEGO cerrar el modal con un pequeño delay para asegurar la navegación
		setTimeout(() => {
			if (onClose) {
				onClose();
			}
		}, 100);
	};

	if (!isOpen) return null;

	return (
		<div
			className="fixed inset-0 z-50 bg-black bg-opacity-70 flex items-center justify-center"
			role="dialog"
			aria-modal="true"
			aria-labelledby="solicitud-exitosa-title"
		>
			{/* 🎊 Confeti: solo en aprobaciones explícitas (prop showConfetti) */}
			{mostrarConfeti && showConfetti && (
				<Confetti
					width={width}
					height={height}
					numberOfPieces={300}
					recycle={false}
				/>
			)}

			<div
				ref={dialogRef}
				tabIndex={-1}
				className="relative bg-white rounded-xl shadow-lg max-w-lg w-full text-center sm:mx-0 mx-4 focus:outline-none"
			>
				<div className="p-8">
					<button
						type="button"
						onClick={handleCerrar}
						aria-label="Cerrar"
						className="absolute top-3 right-3 text-primaryOrange text-2xl font-bold leading-none"
					>
						×
					</button>

					<h2 id="solicitud-exitosa-title" className="text-xl font-bold text-black mb-4">{titulo}</h2>

					<p className="text-gray-600 text-sm">{subtitulo}</p>

					<ul className="text-black-500 text-sm px-8 mt-6 space-y-1">
						{li1 && (
							<li className="list-disc list-inside text-left text-gray-800">
								{li1}
							</li>
						)}
						{li2 && (
							// Verificamos si li2 es un texto o un componente (como tu botón)
							typeof li2 === "string" ? (
								<li className="list-disc list-inside text-left text-gray-800">
									{li2}
								</li>
							) : (
								// Si es un componente, quitamos la viñeta (list-none) y lo centramos
								<li className="flex justify-center items-center list-none mt-4 w-full">
									{li2}
								</li>
							)
						)}
						{li3 && (
							<li className="list-disc list-inside text-left text-gray-800">
								{li3}
							</li>
						)}
					</ul>
				</div>

				{mostrarPie && (
					<div
						className={`${color} p-4 rounded-lg flex items-center justify-between overflow-visible relative`}
					>
						<div>
							<p className="italic text-sm text-gray-800 pl-8 text-center z-10">
								Regresa para ver el detalle de tu solicitud.
							</p>
							<p className="text-sm text-gray-800 pl-8 text-center font-bold z-10">
								¡Gracias por confiar en POINT!
							</p>
						</div>

						{icono === "normal" && (
							<img
								src="https://storage.googleapis.com/sparta_bucket/BANNER/BANN000215/1744323404172_POINTY4.png"
								alt="Mascota"
								className="w-24 h-24 -scale-x-100 flex-shrink-0 -mt-10 z-0"
							/>
						)}

						{icono === "triste" && (
							<img
								src={pointTriste}
								alt="Mascota"
								className="w-32 h-32 -scale-x-100 flex-shrink-0 -mt-10 z-0"
							/>
						)}
					</div>
				)}
			</div>
		</div>
	);
};
